<template>
    <div class="loaderMain">
        <div class="loader-wrapper">
            <div class="midtown_icon">
                <span>
                    <img src="@/assets/images/logo/loader/logo-colored-en.svg" alt="logo" style="max-width: 400px;">
                </span>
                <img class="bg-logo" src="@/assets/images/logo/loader/logo-white-en.svg" alt="logo" style="max-width: 400px;">
            </div>
        </div>
    </div>
</template>